import { ChartConfigVM, TableConfigVM } from "@app/shared-components/chart.interfaces";

export const CHART_CONFIGURATIONS: ChartConfigVM[] = [
    {
        label: 'Completion BOL Summary (In/Out)',
        icon: 'summarize',
        isDefault: true,
        title: 'Completion BOL Summary (In/Out)',
        subtitle: 'Completion Daily Incoming and Outgoing BOLs',
        link: '/vchems-bol/reports/bol-in',
        linkText: 'All BOLs',
        appId: 'vchems-bol',
        tabId: 'bol',
        requestId: 'b9d8a587-d44e-4ed0-b3b9-f15febd17c2b',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/bol',
        roles: ['vchems-bol:admin'],
        metric: [
            {
                name: 'DailyBols',
                type: 'donut',
                metricCol: 'Id'
            }
        ],
        permissions: ['COMPLETION-BOL-VIEW']
    },
    {
        label: 'Production BOL Summary (In/Out)',
        icon: 'summarize',
        isDefault: true,
        title: 'Production BOL Summary (In/Out)',
        subtitle: 'Production Daily Incoming and Outgoing BOLs',
        link: '/vchems-bol/reports/bol-in',
        linkText: 'All BOLs',
        appId: 'vchems-bol',
        tabId: 'bol',
        requestId: 'ed534633-bd07-4d96-b9f6-2e78578bafa8',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/bol',
        roles: ['vchems-bol:admin'],
        metric: [
            {
                name: 'DailyBols',
                type: 'donut',
                metricCol: 'Id'
            }
        ],
        permissions: ['PRODUCTION-BOL-VIEW']
    },
    {
        label: 'BOL Incoming (Production vs. Completions)',
        icon: 'call_received',
        title: 'BOL Incoming (Production vs. Completions)',
        subtitle: 'Production vs. Completions',
        link: '/vchems-bol/reports/bol-out',
        linkText: 'Incoming BOLs',
        appId: 'vchems-bol',
        tabId: 'bol',
        requestId: '8d05d506-1efd-4567-ac10-38a19e506368',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/bol',
        roles: ['vchems-bol:admin'],
        metric: [
            {
                name: 'IncomingBols',
                type: 'donut',
                metricCol: 'Id'
            }
        ],
        permissions: ['PRODUCTION-BOL-VIEW', 'COMPLETION-BOL-VIEW']

    },
    {
        label: 'BOL Outgoing (Production vs. Completions)',
        icon: 'call_made',
        title: 'BOL Outgoing (Production vs. Completions)',
        subtitle: 'Production vs. Completions',
        link: '/vchems-bol/reports/bol-out',
        linkText: 'Outgoing BOL',
        appId: 'vchems-bol',
        tabId: 'bol',
        requestId: '794dc793-1105-4562-87c6-ff2ab29f4a90',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/bol',
        roles: ['vchems-bol:admin', 'vchems-bol:customer'],
        metric: [
            {
                name: 'OutGoingBols',
                type: 'donut',
                metricCol: 'Id'
            }
        ],
        permissions: ['PRODUCTION-BOL-VIEW', 'COMPLETION-BOL-VIEW']

    },
    {
        label: 'E-Ticket Amount By Customer',
        icon: 'confirmation_number',
        title: 'E-Ticket Amount By Customer',
        subtitle: 'Amount By Customer',
        link: '/vchems-bol/reports/eticketing',
        linkText: 'All E-Tickets',
        appId: 'vchems-bol',
        tabId: 'eticketing',
        requestId: 'a1b001f0-c1f2-468a-af05-a1c75d3c8225',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/eticketing',
        roles: ['vchems-bol:admin'],
        permissions: ['ETICKETING-FIELD-READ', 'PRODUCTION-E-TICKETING-VIEW'],
        metric: [
            {
                name: 'eticket',
                type: 'donut',
                metricCol: 'Total'
            }
        ]
    },
    {
        label: 'Completion Received Inventory Products',
        icon: 'call_received',
        title: 'Completion Received Inventory Products',
        subtitle: 'Volume Distribution by Item',
        link: '/vchems-bol/reports/items',
        linkText: 'All Items',
        appId: 'vchems-bol',
        tabId: 'itemreport',
        requestId: 'd36a00de-7340-4a76-aba5-13890df14220',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/itemreport',
        roles: ['vchems-bol:admin'],
        metric: [
            {
                name: 'ri',
                type: 'donut',
                metricCol: 'Volume'

            }
        ],
        permissions: ['COMPLETION-RI-VIEW']

    },
    {
        label: 'Production Received Inventory Products',
        icon: 'call_received',
        title: 'Production Received Inventory Products',
        subtitle: 'Volume Distribution by Item',
        link: '/vchems-bol/reports/items',
        linkText: 'All Items',
        appId: 'vchems-bol',
        tabId: 'itemreport',
        requestId: '8fe27b0b-2599-45c4-9326-4e85cc63139c',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/itemreport',
        roles: ['vchems-bol:admin'],
        metric: [
            {
                name: 'ri',
                type: 'donut',
                metricCol: 'Volume'

            }
        ],
        permissions: ['PRODUCTION-RI-VIEW']

    },
    {
        label: 'Completion Workorder Built products',
        icon: 'call_received',
        title: 'Completion Workorder Built products',
        subtitle: 'Completion Daily Built products',
        link: '/vchems-bol/reports/items',
        linkText: 'All Items',
        appId: 'vchems-bol',
        tabId: 'itemreport',
        requestId: '4bb87772-da92-47d6-b807-b493a063b569',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/itemreport',
        roles: ['vchems-bol:admin'],
        metric: [
            {
                name: 'wo',
                type: 'donut',
                metricCol: 'Volume'
            }
        ],
        permissions: ['COMPLETION-WORKORDER-VIEW']
    },
    {
        label: 'Production Workorder Built products',
        icon: 'call_received',
        title: 'Production Workorder Built products',
        subtitle: 'Production Daily Built products',
        link: '/vchems-bol/reports/items',
        linkText: 'All Items',
        appId: 'vchems-bol',
        tabId: 'itemreport',
        requestId: '6b4bd401-5730-4c53-aa1a-4be1c7c913ba',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/itemreport',
        roles: ['vchems-bol:admin'],
        metric: [
            {
                name: 'wo',
                type: 'donut',
                metricCol: 'Volume'
            }
        ],
        permissions: ['PRODUCTION-WORKORDER-VIEW']
    },
    {
        label: 'Completion BOL Products',
        icon: 'description',
        title: 'Completion BOL Products',
        subtitle: 'Daily Outgoing BOL Products',
        link: '/vchems-bol/reports/items',
        linkText: 'All Items',
        appId: 'vchems-bol',
        tabId: 'itemreport',
        requestId: '77ca9cff-099b-4edc-9185-98535bf451fe',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/itemreport',
        roles: ['vchems-bol:admin', 'vchems-bol:customer'],
        metric: [
            {
                name: 'bolProduct',
                type: 'donut',
                metricCol: 'Volume'
            }
        ],
        permissions: ['COMPLETION-BOL-VIEW']
    },
    {
        label: 'Production BOL Products',
        icon: 'description',
        title: 'Production BOL Products',
        subtitle: 'Daily Outgoing BOL Products',
        link: '/vchems-bol/reports/items',
        linkText: 'All Items',
        appId: 'vchems-bol',
        tabId: 'itemreport',
        requestId: '7fe9223a-3fed-4ee7-9dd4-e3949c4a4240',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/itemreport',
        roles: ['vchems-bol:admin', 'vchems-bol:customer'],
        metric: [
            {
                name: 'bolProduct',
                type: 'donut',
                metricCol: 'Volume'
            }
        ],
        permissions: ['PRODUCTION-BOL-VIEW']
    },
    {
        label: 'Daily Chemical Consumption  (Gals)',
        icon: 'description',
        title: 'Daily Chemical Consumption (Gals)',
        subtitle: 'Daily Chemical Consumption (Gals)',
        appId: 'drill-out',
        tabId: 'blenddatadetail',
        requestId: 'a2ea9782-e22d-43a5-98ae-2269b51110a5',
        filterMap: { 'date': 'Date' },
        roles: ['drill-out:admin'],
        metric: [
            {
                name: 'consumption',
                type: 'donut',
                metricCol: 'ItemVolume'
            }
        ]
    },
    {
        label: 'Mud Blend By Type (BBL)',
        icon: 'description',
        title: 'Mud Blend By Type (BBL)',
        subtitle: 'Mud Blend By Type (BBL)',
        appId: 'drill-out',
        tabId: 'blenddata',
        requestId: '2ffb8fa0-12e5-4caf-96c2-b035cc3c1872',
        filterMap: { 'date': 'Date' },
        roles: ['drill-out:admin'],
        metric: [
            {
                name: 'consumption',
                type: 'donut',
                metricCol: 'Volume'
            }
        ]
    }


];
export const TABLES_COMNFIGURATION: TableConfigVM[] = [
    {
        title: 'Completion BOL',
        icon: 'summarize',
        appId: 'vchems-bol',
        tabId: 'bol',
        requestId: '6a22fb7d-efe6-4408-9c84-bcaed26eab2d',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/bol',
        roles: ['vchems-bol:admin'],
        permissions: ['COMPLETION-BOL-VIEW']
    },
    {
        title: 'Production Bill of Lading',
        icon: 'summarize',
        appId: 'vchems-bol',
        tabId: 'bol',
        requestId: '959dd67f-713d-4610-83ec-5080e8db017e',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/bol',
        roles: ['vchems-bol:admin'],
        permissions: ['PRODUCTION-BOL-VIEW']
    },
    {
        title: 'Completion Eticketing',
        icon: 'confirmation_number',
        appId: 'vchems-bol',
        tabId: 'itemreport',
        requestId: '8c69738f-27a7-487e-8368-87a9b6564f9e',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/itemreport',
        roles: ['vchems-bol:admin'],
        permissions: ['COMPLETION-E-TICKETING-VIEW']
    },
    {
        title: 'Production Eticketing',
        icon: 'confirmation_number',
        appId: 'vchems-bol',
        tabId: 'itemreport',
        requestId: '826694ba-c714-403b-888e-f3e415de8813',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/itemreport',
        roles: ['vchems-bol:admin'],
        permissions: ['PRODUCTION-E-TICKETING-VIEW']
    },
    {
        title: 'Rig Reading Data',
        icon: 'summarize',
        appId: 'drill-out',
        tabId: 'rigreading',
        requestId: '15080e99-abfe-453e-a3c5-679e7f1e2165',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/drill-out/rigreading',
        roles: ['drill-out:admin']
    },
    {
        title: 'Completion Received Inventory',
        icon: 'summarize',
        appId: 'vchems-bol',
        tabId: 'itemreport',
        requestId: '95700096-6b48-42fc-9f02-212f1a13e02a',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/itemreport',
        roles: ['vchems-bol:admin'],
        permissions: ['COMPLETION-RI-VIEW']
    },
    {
        title: 'Production Received Inventory',
        icon: 'summarize',
        appId: 'vchems-bol',
        tabId: 'itemreport',
        requestId: 'c429a155-f153-4832-8e65-e1bb184aeee6',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/itemreport',
        roles: ['vchems-bol:admin'],
        permissions: ['PRODUCTION-RI-VIEW']
    },
    {
        title: 'Completion Assembly Builds',
        icon: 'summarize',
        appId: 'vchems-bol',
        tabId: 'assemblybuild',
        requestId: '837a0647-1e4a-41f3-aee5-c5d619d169cb',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/receivedinventory',
        roles: ['vchems-bol:admin'],
        permissions: ['COMPLETION-WORKORDER-VIEW']
    },
    {
        title: 'Production Assembly Builds',
        icon: 'summarize',
        appId: 'vchems-bol',
        tabId: 'assemblybuild',
        requestId: 'eea430e6-a7a6-43d7-8041-aef6d9b157ab',
        filterMap: { 'date': 'Date' },
        serviceUrl: '/api/SearchData/vchems-bol/receivedinventory',
        roles: ['vchems-bol:admin'],
        permissions: ['PRODUCTION-WORKORDER-VIEW']
    }


]

 